<div class="container-fluid" id="add-sensor-page">
    <div class="row">
        <div class="col align-self-center">
            <h3 class="text-center font-weight-bold title" id="title">{{ pageController.pageTitle }}</h3>
        </div>
    </div>
    <div class="row" id="stepper-circle">
        <div class="stepper-form row">
            <div class="stepper-row d-flex justify-content-between">
                <div class="stepper-step"
                     *ngFor="let check of pageController.stepCompletionChecks; let i = index" id="checks">
                    <div ngClass="{{check.completed === true ?
            'btn-circle activated': !check.nodeVisited ?
              'btn-circle inactive' : 'btn-circle current-step-'+(i+1)}}">
                        <i class="fa fa-check" aria-hidden="true" *ngIf="check.completed === true"></i>
                        <div *ngIf="pageController.isNodeVisitedAndNotCompleted(i)">{{ i + 1 }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="stepper-text">
        <div class="row">
            <div *ngFor="let stepper of pageController.stepperTexts; let i = index">
                <div id="stepper-text-{{ i + 1 }}"
                     ngClass="{{i===pageController.currentStep ? 'stepper-description enabled': 'stepper-description disabled'}}">
                    {{ stepper.text }}
                </div>
            </div>
        </div>
    </div>
    <div class="row" id="add-new-sensor-form">
        <form [formGroup]="createSensorForm" novalidate>
            <div [ngSwitch]="pageController.currentStep">
                <div *ngSwitchCase="0" id="type-and-name-tab">
                    <div class="form-group">
                        <label>Select a sensor type and give the sensor a name.</label>
                    </div>
                    <div class="form-group">
                        <label class="font-weight-bold">Sensor type*</label>
                        <div id="select-sensor-type">
                            <select id="sensor-type" class="custom-select rounded-0" formControlName="sensorType">
                                <option *ngFor="let sensorType of sensorTypes"
                                        [ngValue]="sensorType">
                                    {{ sensorType.description }}
                                </option>
                            </select>
                            <div *ngIf="addNewSensorFormController.sensorTypeControl.invalid" class="text-danger ml-2">
                                <div *ngIf="addNewSensorFormController.sensorTypeControl.errors['required']">
                                    {{ validatorMessage.Required }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="font-weight-bold">Sensor Name</label>
                        <div id="sensor-name-sap">
                            <input type="text" id="sensor-name" class="custom-text-input"
                                   placeholder="Name of the sensor (= functieplaats)"
                                   formControlName="sensorName" [maxlength]="55" [required]="true">
                            <div *ngIf="addNewSensorFormController.sensorNameControl.invalid" class="text-danger ml-2">
                                <div *ngIf="addNewSensorFormController.sensorNameControl.errors['required']">
                                    {{ validatorMessage.Required }}
                                </div>
                                <div *ngIf="addNewSensorFormController.sensorNameControl.errors['forbiddenName']">
                                    Name {{ addNewSensorFormController.sensorNameControl.errors['forbiddenName'].value }} is already used
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngSwitchCase="1" id="device-tab">
                    <div class="form-row row">
                        <div class="form-group">
                            <span>Select the device from the list</span>
                            <div *ngIf="addNewSensorFormController.deviceControl.invalid" class="text-danger float-right">
                                <div *ngIf="addNewSensorFormController.deviceControl.errors['required']">
                                    {{ validatorMessage.Required }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row row" *ngIf="devices?.length > 0">
                        <div class="form-group col-md-12">
                            <div *ngFor="let device of devices; let i = index">
                                <h6 class="font-weight-bold">Device ID: {{ device.deviceId }}</h6>
                                <button class="btn rounded-0 float-right"
                                        [ngClass]="{'device-selected': device.isSelected(), 'device-not-selected': !device.isSelected()}"
                                        id="select-device"
                                        value="i"
                                        (click)="deviceController.selectDevice($event, i);
                                 addNewSensorFormController.setLocationName(device.location)">
                                    {{ device.getText() }}
                                </button>
                                <div>Device Type: {{ device.deviceType }}</div>
                                <div>Gateway ID: {{ device.gatewayId }}</div>
                                <div>Gateway Type ID: {{ device.gatewayTypeId }}</div>
                                <div>Location: {{ device.location }}</div>
                                <span>Date Added: {{ device.dateAdded | date: 'dd/MM/yyyy' }}</span>
                                <hr/>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngSwitchCase="2" id="information-tab">
                    <div class="form-row row">
                        <div class="form-group">
                            <span>Enter more general information about the sensor for identification</span>
                        </div>
                    </div>
                    <div class="form-row row">
                        <div class="form-group">
                            <label class="font-weight-bold">Instrument type</label>
                            <div id="instrument-type">
                                <input type="text" id="instrument-type-text" formControlName="instrumentType"
                                       class="custom-text-input" placeholder="E.g. Radar" [maxlength]="255">
                            </div>
                            <div *ngIf="addNewSensorFormController.instrumentTypeControl.invalid" class="text-danger">
                                <div *ngIf="addNewSensorFormController.instrumentTypeControl.errors['required']">
                                    {{ validatorMessage.Required }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row row">
                        <div class="form-group">
                            <label class="font-weight-bold">Sensor Location name</label>
                            <div id="location-name">
                                <input type="text" id="location-name-text" formControlName="locationName"
                                       class="custom-text-input" [maxlength]="40"
                                       placeholder="Sensor Location name (= Feature Description)">
                            </div>
                            <div *ngIf="addNewSensorFormController.locationNameControl.invalid" class="text-danger">
                                <div *ngIf="addNewSensorFormController.locationNameControl.errors['required']">
                                    {{ validatorMessage.Required }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row row">
                        <div class="form-group col-md-6">
                            <label class="font-weight-bold">Start date sensor operational</label>
                            <div id="start-date-sensor">
                                <input type="date"
                                       class="custom-text-input"
                                       id="start-date-sensor-operational"
                                       formControlName="startDate"
                                       placeholder="DD/MM/YYYY"
                                       required/>
                            </div>
                            <div *ngIf="addNewSensorFormController.startDateControl.invalid" class="text-danger">
                                {{ validatorMessage.Required }}
                            </div>
                        </div>
                        <div class="form-group col-md-6">
                            <label class="font-weight-bold">End date sensor operational</label>
                            <div id="end-date-sensor">
                                <input type="date"
                                       class="custom-text-input"
                                       id="end-date-sensor-operational"
                                       formControlName="endDate"
                                       placeholder="DD/MM/YYYY"/>
                            </div>
                            <div *ngIf="addNewSensorFormController.endDateControl.invalid" class="text-danger">
                                <div *ngIf="addNewSensorFormController.endDateControl.errors['invalidEndDate']">
                                    {{ validatorMessage.InvalidEndDate }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row row">
                        <label class="col-md-12 form-group font-weight-bold coordinates-label">
                            Coordinates of sensor location
                        </label>
                    </div>
                    <div class="form-row row">
                        <div class="form-group col-md-4">
                            <label>X-position RD</label>
                            <div id="x-position-rd">
                                <input type="text" id="location-x" class="custom-text-input"
                                       formControlName="locationX" [readonly]="false"
                                       placeholder="E.g. 59315" [maxlength]="10"
                                       [required]="true">
                            </div>
                            <div *ngIf="addNewSensorFormController.locationXControl.invalid" class="text-danger">
                                <div *ngIf="addNewSensorFormController.locationXControl.errors['required']">
                                    {{ validatorMessage.Required }}
                                </div>
                                <div *ngIf="addNewSensorFormController.locationXControl.errors['pattern']">
                                    {{ validatorMessage.Decimal }}
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-md-4">
                            <label>Y-position RD</label>
                            <div id="y-position-rd">
                                <input type="text" id="location-y" class="custom-text-input"
                                       formControlName="locationY" [readonly]="false"
                                       placeholder="E.g. 59315" [maxlength]="10"
                                       [required]="true">
                            </div>
                            <div *ngIf="addNewSensorFormController.locationYControl.invalid" class="text-danger">
                                <div *ngIf="addNewSensorFormController.locationYControl.errors['required']">
                                    {{ validatorMessage.Required }}
                                </div>
                                <div *ngIf="addNewSensorFormController.locationYControl.errors['pattern']">
                                    {{ validatorMessage.Decimal }}
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-md-4">
                            <label>Z-position NAP in M</label>
                            <div id="z-position-nap">
                                <input type="text" id="location-z" class="custom-text-input"
                                       formControlName="locationZ"
                                       placeholder="E.g. 59315" [maxlength]="10">
                            </div>
                            <div *ngIf="addNewSensorFormController.locationZControl.invalid" class="text-danger">
                                <div *ngIf="addNewSensorFormController.locationZControl.errors['pattern']">
                                    {{ validatorMessage.Decimal }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row row">
                        <label class="col-md-12 form-group font-weight-bold coordinates-label">Coordinates of
                            measurement locations
                        </label>
                    </div>
                    <div class="row add-measurement">
                        <div class="col-md-12 add-measurement-text">
                            <a (click)="measurementLocationFormController.resetMeasurementLocationForm();
                          measurementLocationFormController.setFirstFeatureType(this.featureTypes);
                          measurementLocationFormController.setFeatureName(addNewSensorFormController.locationName);
                          addSensorModal.show();"
                               id="add-measurement-location-button">
                                + Add measurement location
                            </a>
                            <span *ngIf="addNewSensorFormController.measurementLocationsControl.invalid" class="text-danger">
                &nbsp; {{ validatorMessage.Required }}
              </span>
                        </div>
                        <div class="col-md-12 no-padding">
                            <table *ngIf="measurementLocationFormController.measurementLocations.length > 0"
                                   class="table table-responsive-md table-striped measurement-content">
                                <thead class="thead-blue">
                                <tr>
                                    <th>#</th>
                                    <th>Type</th>
                                    <th>Name</th>
                                    <th>X-position</th>
                                    <th>Y-position</th>
                                    <th>Z-position</th>
                                    <th>End Date</th>
                                    <th>Actions</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr *ngFor="let measurement of measurementLocationFormController.measurementLocations; let i=index;"
                                    (click)="addSensorModal.show();measurementLocationFormController.setMeasurementInActiveForm(i);">
                                    <td>{{ i + 1 }}</td>
                                    <td id='feature-type-{{ i+1 }}'>{{ measurement.type }}</td>
                                    <td id='feature-name-{{ i+1 }}'>{{ measurement.name }}</td>
                                    <td id='x-position-{{ i+1 }}'>{{ measurement.x }}</td>
                                    <td id='y-position-{{ i+1 }}'>{{ measurement.y }}</td>
                                    <td id='z-position-{{ i+1 }}'>{{ measurement.z }}</td>
                                    <td class="end-date-{{ i+1 }}">{{ measurement.endDate | date: "dd/MM/yyyy" }}</td>
                                    <td class="icon-in-table"><i class='fa fa-pencil-square-o'></i></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div *ngSwitchCase="3" id="summary-tab">
                    <div class="form-row row">
                        <div class="form-group">
                            <span>Verify the following information is correct and then add the sensor</span>
                        </div>
                    </div>
                    <div class="form-row row">
                        <div class="form-group col-md-6">
                            <h6>{{ addNewSensorFormController.sensorName }}</h6>
                            <div id="sensor-type-result">
                                Sensor Type: {{ addNewSensorFormController.sensorType.description }}
                            </div>
                            <div id="instrument-type-result">
                                Measurement Type: {{ addNewSensorFormController.instrumentType }}
                            </div>
                            <div id="location-name-result">
                                Location: {{ addNewSensorFormController.locationName }}
                            </div>
                            <div id="start-date-result" *ngIf="addNewSensorFormController.startDate">
                                Start date sensor operational: {{ addNewSensorFormController.startDate | date: "dd/MM/yyyy" }}
                            </div>
                            <div id="end-date-result" *ngIf="addNewSensorFormController.endDate">
                                End date sensor operational: {{ addNewSensorFormController.endDate | date: "dd/MM/yyyy" }}
                            </div>
                        </div>
                        <div class="form-group col-md-6">
                            <h6>Sensor connected to device</h6>
                            <div>Device ID: {{ addNewSensorFormController.device.deviceId }}</div>
                            <div>Device type: {{ addNewSensorFormController.device.deviceType }}</div>
                            <div>Date added: {{ addNewSensorFormController.device.dateAdded | date:'dd-MM-yyyy' }}
                            </div>
                        </div>
                    </div>
                    <div class="form-row row">
                        <div class="form-group" id="location-item-table-wrapper">
                            <h6>Coordinates of sensor and feature(s)</h6>
                            <app-table
                                    [tableRowObjects]="addNewSensorFormController.summaryMeasurementLocations"
                                    [tableAttributes]="tableProperties"
                                    id="location-item-table">
                            </app-table>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>

<footer class="footer container-fluid">
    <div class="row justify-content-center">
        <div class="col-auto">
            <button type="button" class="btn custom-button-por-blue" id="button-back-to-sensor"
                    (click)="backToSensorsOverview()">{{ pageController.navigationTextBackToSensor }}
            </button>
        </div>
        <div class="col-auto">
            <button type="button"
                    class="btn custom-button-por-yellow"
                    [disabled]="isPreviousButtonDisabledAtStep(pageController.currentStep)"
                    id="button-previous-step" (click)="goToPreviousStep()">
                <i class="fa fa-angle-left" aria-hidden="true"></i>
                {{ pageController.navigationTextBackward }}
            </button>
        </div>
        <div class="col-auto">
            <button type="button"
                    class="btn custom-button-por-yellow"
                    [disabled]="isNextButtonDisabledAtStep(pageController.currentStep)"
                    id="button-next-step" (click)="goToNextStep()">
                {{ pageController.navigationTextForward }}
                <i class="fa fa-angle-right" aria-hidden="true"></i>
            </button>
        </div>
    </div>
</footer>

<app-modal class="app-modal" #addSensorModal>
    <div class="app-modal-header">
        <ng-container *ngIf="!measurementLocationFormController.isEdit; else showEditHeader">
            Add measurement location
        </ng-container>
        <ng-template #showEditHeader>
            Edit measurement location
        </ng-template>
    </div>
    <div class="app-modal-body">
        <h6 class="row mx-0 mt-2">
            You can {{ measurementLocationFormController.isEdit ? 'edit' : 'add' }} the measurement
            location information
        </h6>
        <form [formGroup]="measurementLocationForm" novalidate>
            <div class="form-row row mx-0 mt-2">
                <label class="font-weight-bold">Type (of Feature)</label>
                <select id="feature-type" class="custom-select rounded-0" formControlName="featureType">
                    <option *ngFor="let featureType of featureTypes"
                            [ngValue]="featureType.name">
                        {{ featureType.name }}
                    </option>
                </select>
            </div>
            <div class="form-row row mx-0 mt-2">
                <label class="font-weight-bold">Feature Name</label>
                <input id="feature-name" type="text" class="form-control squared"
                       formControlName="featureName" [maxlength]="40"
                       placeholder="E.g. NRDP"/>
                <span *ngIf="measurementLocationFormController.featureNameControl.invalid" class="text-danger">
          <span *ngIf="measurementLocationFormController.featureNameControl.errors['required']">
            {{ validatorMessage.Required }}
          </span>
        </span>
            </div>
            <div class="form-row row mx-0 mt-2">
                <label class="font-weight-bold">Feature Description</label>
                <input id="feature-description" type="text" class="form-control squared"
                       formControlName="featureDescription" [maxlength]="254"
                       placeholder="E.g. Noorderpier"/>
                <span *ngIf="measurementLocationFormController.featureDescriptionControl.invalid" class="text-danger">
          <span *ngIf="measurementLocationFormController.featureDescriptionControl.errors['required']">
            {{ validatorMessage.Required }}
          </span>
        </span>
            </div>
            <div class="form-row row mx-0 mt-2">
                <div class="col-md-4 pl-0">
                    <label>X-position RD</label>
                    <div id="x-position">
                        <input id="x-position-input" type="text" class="form-control squared"
                               formControlName="xCoordinateMeasurement" [maxlength]="10"
                               placeholder="E.g. 59315"/>
                    </div>
                    <div *ngIf="measurementLocationFormController.xCoordinateMeasurementControl.invalid"
                         class="text-danger">
                        <div *ngIf="measurementLocationFormController.xCoordinateMeasurementControl.errors['required']">
                            {{ validatorMessage.Required }}
                        </div>
                        <div *ngIf="measurementLocationFormController.xCoordinateMeasurementControl.errors['pattern']">
                            {{ validatorMessage.Decimal }}
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <label>Y-position RD</label>
                    <div id="y-position">
                        <input id="y-position-input" type="text" class="form-control squared"
                               [maxlength]="10"
                               formControlName="yCoordinateMeasurement"
                               placeholder="E.g. 59315"/>
                    </div>
                    <div *ngIf="measurementLocationFormController.yCoordinateMeasurementControl.invalid"
                         class="text-danger">
                        <div *ngIf="measurementLocationFormController.yCoordinateMeasurementControl.errors['required']">
                            {{ validatorMessage.Required }}
                        </div>
                        <div *ngIf="measurementLocationFormController.yCoordinateMeasurementControl.errors['pattern']">
                            {{ validatorMessage.Decimal }}
                        </div>
                    </div>
                </div>
                <div class="col-md-4 pr-0">
                    <label>Z-position RD</label>
                    <div id="z-position">
                        <input id="z-position-input" type="text" class="form-control squared"
                               formControlName="zCoordinateMeasurement"
                               [maxlength]="10"
                               placeholder="E.g. 59315"/>
                    </div>
                    <div *ngIf="measurementLocationFormController.zCoordinateMeasurementControl.invalid" class="text-danger">
                        <div *ngIf="measurementLocationFormController.zCoordinateMeasurementControl.errors['pattern']">
                            {{ validatorMessage.Decimal }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-row row mx-0 mt-2">
                <div class="col-md-6">
                    <label class="font-weight-bold">End Date</label>
                    <input type="date"
                           id="edit-feature-end-date"
                           class="custom-text-input"
                           formControlName="endDate"
                           [disabled]="true"
                           placeholder="DD/MM/YYYY"/>
                    <div *ngIf="measurementLocationFormController.endDateControl.invalid" class="text-danger">
                        <div *ngIf="measurementLocationFormController.endDateControl.errors['invalidEndDate']">
                            {{ validatorMessage.InvalidEndDate }}
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="measurementLocationForm.get('featureType').value == 'Tidal stream'">
                <h6 class="form-row mt-2 pl-1 font-weight-bold">Metadata</h6>
                <div class="form-row">
                    <label class="col-5 mt-1">Distance</label>
                    <input id="distance"
                           type="text"
                           class="form-control squared col-3 mb-1"
                           formControlName="distance"
                           [required]="true" placeholder="..."/>
                    <span *ngIf="measurementLocationFormController.distanceControl.invalid" class="text-danger col-4 mt-1">
            <span class="float-right">
              <span *ngIf="measurementLocationFormController.distanceControl.errors['required']">
              {{ validatorMessage.Required }}
              </span>
              <span *ngIf="measurementLocationFormController.distanceControl.errors['pattern']">
              {{ validatorMessage.PositiveInteger }}
              </span>
            </span>
          </span>
                </div>
                <div class="form-row">
                    <label class="col-5 mt-1">Minimum Flood Direction (clockwise in degrees)</label>
                    <input id="direction-from"
                           type="text"
                           class="form-control squared col-3 mb-1"
                           formControlName="directionFrom"
                           placeholder="E.g. 45"
                           [required]="true"/>
                    <span *ngIf="measurementLocationFormController.directionFromControl.invalid" class="text-danger col-4 mt-1">
            <span class="float-right">
              <span *ngIf="measurementLocationFormController.directionFromControl.errors['required']">
                {{ validatorMessage.Required }}
              </span>
              <span *ngIf="measurementLocationFormController.directionFromControl.errors['pattern']">
                {{ validatorMessage.PositiveInteger }}
              </span>
              <span *ngIf="measurementLocationFormController.directionFromControl.errors['invalidRange']">
                {{ validatorMessage.InvalidRange }}
              </span>
            </span>
          </span>
                </div>
                <div class="form-row">
                    <label class="col-5 mt-1">Maximum Flood Direction (clockwise in degrees)</label>
                    <input id="direction-to"
                           type="text"
                           class="form-control squared col-3 mb-1"
                           formControlName="directionTo"
                           placeholder="E.g. 320"
                           [required]="true"/>
                    <span *ngIf="measurementLocationFormController.directionToControl.invalid" class="text-danger col-4 mt-1">
            <span class="float-right">
              <span *ngIf="measurementLocationFormController.directionToControl.errors['required']">
                {{ validatorMessage.Required }}
              </span>
              <span *ngIf="measurementLocationFormController.directionToControl.errors['pattern']">
                {{ validatorMessage.PositiveInteger }}
              </span>
              <span *ngIf="measurementLocationFormController.directionToControl.errors['invalidRange']">
                {{ validatorMessage.InvalidRange }}
              </span>
            </span>
          </span>
                </div>
            </div>
            <div *ngIf="measurementLocationForm.get('featureType').value == 'Height of tide'">
                <h6 class="form-row mt-2 pl-1 font-weight-bold">Metadata</h6>
                <div class="form-row">
                    <label class="col-5 mt-1">NAP to ALAT conversion (cm)</label>
                    <input id="napToALatConversion"
                           type="text"
                           class="form-control squared col-3 mb-1"
                           formControlName="napToALatConversion"
                           [required]="true"/>
                    <span *ngIf="measurementLocationFormController.napToALatConversionControl.invalid"
                          class="text-danger col-4 mt-1">
            <span class="float-right">
              <span *ngIf="measurementLocationFormController.napToALatConversionControl.errors['required']">
              {{ validatorMessage.Required }}
              </span>
              <span *ngIf="measurementLocationFormController.napToALatConversionControl.errors['pattern']">
              {{ validatorMessage.PositiveDecimal }}
              </span>
            </span>
          </span>
                </div>
            </div>
        </form>
    </div>
    <div class="app-modal-footer">
        <div class="row">
            <div class="col-md-6">
                <button type="button" id="closeModal" class="btn custom-button-por-blue float-left"
                        (click)="addSensorModal.hide()">CLOSE
                </button>
            </div>
            <div class="col-md-6">
                <button type="button" id="save-and-close-modal"
                        class="btn custom-button-por-yellow float-right"
                        (click)="measurementLocationFormController.submitMeasurementLocationData(); addSensorModal.hide()"
                        [disabled]="measurementLocationFormController.disableAddMeasurementLocation()">
                    <ng-container *ngIf="!measurementLocationFormController.isEdit; else showEdit">
                        ADD
                    </ng-container>
                    <ng-template #showEdit>CHANGE</ng-template>
                </button>
            </div>
        </div>
    </div>
</app-modal>
